module.exports = __webpack_public_path__ + "static/media/b1.d68bc34.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/songyimin/b1.mp3
// module id = GNyr
// module chunks = 0